// extracted by mini-css-extract-plugin
export default {"row":"mfaxrnqsRxlOzUJl4Kve","cell":"r1yQ6rXO97_ZAaRNVwCA"};